    import { createApi } from "@reduxjs/toolkit/query/react";
    import { api } from "../../../api/Api.jsx";

    export const JoinStudent = createApi({
        reducerPath: 'JoinStudent',
        baseQuery: api,  
        tagTypes: ['JoinStudent'],
        endpoints: (build) => ({
            getJoinStudent: build.query({
                query: (body) => `students/get_added_students/`,
                providesTags: ['tagTypes'],

            }),
            addJoinStudent: build.mutation({
                query: (body) => ({
                    url: `student_discounts/`,
                    method: "POST",
                    body,
                }),
                invalidatesTags: ["tagTypes"],
            }),
        }),
    });

    export const {
        useGetJoinStudentQuery,
        useAddStudentDiscountMutation,

    } = JoinStudent;